import { useEffect } from 'react';
import { brandIsPw } from '@/shared/config/brand-by-target.mjs';
import { useCurrency } from '@/shared/ui/selects/select-currency/model/hooks';

const JACKPOT_LOGO = brandIsPw ? 'pw' : 'vms';

export function useJackpotCurrency() {
  const { data: currencies, isLoading, error } = useCurrency();

  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);

  const isReady = !isLoading && Boolean(currencies);
  const currency = currencies?.find((c) => c.active)?.currency ?? 'USD';
  const jackpotUrl = `${process.env.NEXT_PUBLIC_JACKPOT_URL}?currency=${currency}`;

  return { isReady, currency, jackpotUrl, logo: JACKPOT_LOGO };
}
